import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppNav } from 'src/routes/app-nav';
import { Observable, map } from 'rxjs';
import { API_BASE_URI } from 'src/shared/constants';
import { QueryListRespDTO, QueryRespDTO } from '@/classes/QueryRespDTO';
import { ApiResponse } from '@/interfaces/apiresponse.interface';
import { PutQueryReqDTO } from '@/interfaces/putQueryReqDTO.interface';
import { DateValidatorDTO } from '@/classes/dateValidatorDTO';
import { serialize } from 'object-to-formdata';

@Injectable({ providedIn: 'root' })
export class QueryService {
  AppNav = AppNav;

  constructor(private http: HttpClient) {}

  getQueryByRequestId(requestId: string): Observable<QueryRespDTO> {
    const url = API_BASE_URI + '/api/query/' + requestId;

    return this.http.get<QueryRespDTO>(url);
  }

  getQueries(): Observable<QueryListRespDTO[]> {
    const url = API_BASE_URI + '/api/query';

    return this.http.get<QueryListRespDTO[]>(url);
  }

  putQuery(req: PutQueryReqDTO): Observable<ApiResponse> {
    const url = API_BASE_URI + '/api/query';
    return this.http.put<ApiResponse>(url, serialize(req));
  }

  terminateQuery(requestId: string): Observable<ApiResponse> {
    const url = API_BASE_URI + `/api/query/${requestId}/terminate`;

    return this.http.delete<ApiResponse>(url);
  }

  validateTechnicalUserByVatNumber(vatNumber: string): Observable<ApiResponse> {
    let url = API_BASE_URI + `/api/query/technicalUser/${vatNumber}/validate`;

    return this.http.get<ApiResponse>(url);
  }

  getTechnicalAvailableDates(vatNumber: string): Observable<DateValidatorDTO> {
    let url =
      API_BASE_URI + `/api/query/technicalUser/${vatNumber}/AvailableDates`;

    return this.http
      .get<string[]>(url)
      .pipe(map((r) => ({ minDate: new Date(r[0]), maxDate: new Date(r[1]) })));
  }
}
